const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const { logError } = require('../../logger');

const Roundhouse = function (battleState) {
  this.handle = 'roundhouse';
  this.physical = true;
  this.weapon = true;
  this.melee = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    setTimeout(() => {
      try {
        var ability = BattleCalc.getEquippedAbility(actor, this.handle);
        var dist;
        var strikes = [];

        for (var prop in battleState.allUnits) {
          var guy = battleState.allUnits[prop];
          dist = BattleCalc.boardDistance(actor, guy);
          if (dist <= 2 && guy.uid !== actor.uid) {
            var strike = this.standardStrike.execute(
              actor,
              guy,
              ability.damage / dist,
              true
            );
          }
        }

        var result = { strikes };
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.allPieces = battleState.allPieces;
        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'Roundhouse',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.getCooldown(actor) * 0.52 * 1000);
  };
};
module.exports = Roundhouse;
